import React from 'react'

interface ModelsGridProps {
  viewMode: 'grid' | 'list'
  children: React.ReactNode
}

const ModelsGrid: React.FC<ModelsGridProps> = ({ viewMode, children }) => {
  return (
    <div
      className="d-grid p-0"
      style={{
        gridTemplateColumns: viewMode === 'list' ? '1fr' : 'repeat(auto-fill, minmax(350px, 1fr))',
        gap: viewMode === 'list' ? '0.5rem' : '1.5rem',
      }}
    >
      {children}
    </div>
  )
}

export default ModelsGrid
